import { render, staticRenderFns } from "./PayByMethod.vue?vue&type=template&id=9b24cf6e&scoped=true"
import script from "./PayByMethod.vue?vue&type=script&lang=js"
export * from "./PayByMethod.vue?vue&type=script&lang=js"
import style0 from "./PayByMethod.vue?vue&type=style&index=0&id=9b24cf6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b24cf6e",
  null
  
)

export default component.exports